// Function to generate a chord-like slug (to be used as URL-friendly identifier)
export const generateChordSlug = (): string => {
  const consonants = 'bcdfghjklmnpqrstvwxyz';
  const vowels = 'aeiou';
  const getRandomChar = (chars: string) => chars.charAt(Math.floor(Math.random() * chars.length));
  
  // Generate pattern like 'consonant + vowel + consonant + vowel + consonant'
  const slug = 
    getRandomChar(consonants) + 
    getRandomChar(vowels) +
    getRandomChar(consonants) + 
    getRandomChar(vowels) +
    getRandomChar(consonants);
  
  // Add a random 3-digit number
  const randomNum = Math.floor(Math.random() * 900) + 100;
  
  return `${slug}${randomNum}`;
};